import React from 'react';
import MultiPartitionResilientDNS from './partition_resilient_dns';

function App() {
  return <MultiPartitionResilientDNS />;
}

export default App;
